// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Ocean-2.4s-3000px.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundLogin {
  /* background: linear-gradient(120deg, #eee, #fff 100%); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100%;
  min-height: 100vh;
  background-size: cover;
}

.LoginLanding {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.LoginWrap {
  position: relative;
  background: linear-gradient(to right, #44AA99 0%, #332288 100%);

  /* background: #000000; */
  width: 810px;
  height: 610px;
}

.LoginLoginBox {
  /* background: #ffffff; */
  margin: 5px 5px 5px 5px;
  padding: 20px;
  width: 800px;
  height: 600px;
}

.LoginLoginBox h1 {
  font-family: "IBM Plex Sans", sans-serif;
  font-weight: 500;
  font-size: xx-large;
  text-align: center;
  margin-bottom: 5vh;
  background: linear-gradient(to right, #44AA99 0%, #332288 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.LoginLoginBox p {
  text-align: left;
  font-size: small;
}

.LoginBox Button {
  float: right;
}
#loginButton .p-button {
  background: linear-gradient(to right, #44AA99 0%, #332288 100%) !important;
  border: 0px;
  padding-left: 50px;
  padding-right: 50px;
}

.LoginSplit {
  height: 100%;
  width: 40%;
  position: fixed;
  z-index: 1;
  top: 0;
  overflow-x: hidden;
  padding-top: 20px;
}

.LoginLeft {
  width: 60%;
  background-color: #ffffff;
  background-size: cover;
  /* Background image for represenation only in proto type, to be replaced before production; copyrights not held */
  /* background-image: url('../../assets/Ocean-2.4s-3000px.svg'); */
}

.LoginRight {
  right: 0;
  background-color: #ffffff;
  min-width: 610px;
}

.LoginCentered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.LoginCentered img {
  width: 150px;
}

.LoginLeftH {
  font-family: "IBM Plex Sans", sans-serif;
  padding-left: 5vh;
  margin-bottom: 5vh;
}
`, "",{"version":3,"sources":["webpack://./src/scene-d/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D,yDAA2D;EAC3D,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,+DAA+D;;EAE/D,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,+DAA+D;EAC/D,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;AACA;EACE,0EAA0E;EAC1E,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;EACV,MAAM;EACN,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,iHAAiH;EACjH,iEAAiE;AACnE;;AAEA;EACE,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".BackgroundLogin {\n  /* background: linear-gradient(120deg, #eee, #fff 100%); */\n  background-image: url('../../assets/Ocean-2.4s-3000px.svg');\n  width: 100%;\n  min-height: 100vh;\n  background-size: cover;\n}\n\n.LoginLanding {\n  min-height: 70vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.LoginWrap {\n  position: relative;\n  background: linear-gradient(to right, #44AA99 0%, #332288 100%);\n\n  /* background: #000000; */\n  width: 810px;\n  height: 610px;\n}\n\n.LoginLoginBox {\n  /* background: #ffffff; */\n  margin: 5px 5px 5px 5px;\n  padding: 20px;\n  width: 800px;\n  height: 600px;\n}\n\n.LoginLoginBox h1 {\n  font-family: \"IBM Plex Sans\", sans-serif;\n  font-weight: 500;\n  font-size: xx-large;\n  text-align: center;\n  margin-bottom: 5vh;\n  background: linear-gradient(to right, #44AA99 0%, #332288 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.LoginLoginBox p {\n  text-align: left;\n  font-size: small;\n}\n\n.LoginBox Button {\n  float: right;\n}\n#loginButton .p-button {\n  background: linear-gradient(to right, #44AA99 0%, #332288 100%) !important;\n  border: 0px;\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.LoginSplit {\n  height: 100%;\n  width: 40%;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  overflow-x: hidden;\n  padding-top: 20px;\n}\n\n.LoginLeft {\n  width: 60%;\n  background-color: #ffffff;\n  background-size: cover;\n  /* Background image for represenation only in proto type, to be replaced before production; copyrights not held */\n  /* background-image: url('../../assets/Ocean-2.4s-3000px.svg'); */\n}\n\n.LoginRight {\n  right: 0;\n  background-color: #ffffff;\n  min-width: 610px;\n}\n\n.LoginCentered {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.LoginCentered img {\n  width: 150px;\n}\n\n.LoginLeftH {\n  font-family: \"IBM Plex Sans\", sans-serif;\n  padding-left: 5vh;\n  margin-bottom: 5vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
